import { NumericFormat } from 'react-number-format';

const inputClass = 'w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold outline-none focus:border-blue-500';

// Form state and API values stay in nominal currency units.
const PersonnelCompensationFields = ({ formData, onChange, showEmploymentType = true }) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
    {showEmploymentType && (
      <label>
        <span className="mb-2 block text-sm font-bold">Personel Tipi</span>
        <select className={inputClass} value={formData.employmentType || 'FIXED'} onChange={(e) => onChange('employmentType', e.target.value)}>
          <option value="FIXED">Sabit</option>
          <option value="DAILY">Yevmiyeli</option>
        </select>
      </label>
    )}
    {(formData.employmentType || 'FIXED') === 'FIXED' && (
      <label>
        <span className="mb-2 block text-sm font-bold">Personel Grubu</span>
        <select className={inputClass} value={formData.personnelGroup || ''} onChange={(e) => onChange('personnelGroup', e.target.value || null)}>
          <option value="">Seçiniz</option>
          <option value="SUPERVISOR">Süpervizör</option>
          <option value="OFFICE">Ofis</option>
          <option value="FIELD">Saha</option>
        </select>
      </label>
    )}
    <label>
      <span className="mb-2 block text-sm font-bold">Günlük Ücret</span>
      <NumericFormat
        className={inputClass}
        value={formData.dailyRate ?? 0}
        thousandSeparator="."
        decimalSeparator=","
        allowedDecimalSeparators={[',', '.']}
        decimalScale={2}
        fixedDecimalScale
        allowNegative={false}
        inputMode="decimal"
        suffix={` ${formData.currency || 'TRY'}`}
        onFocus={(event) => event.target.select()}
        isAllowed={({ floatValue }) => floatValue === undefined || Number.isFinite(floatValue)}
        onValueChange={({ floatValue }, source) => {
          if (source.source === 'event') onChange('dailyRate', floatValue ?? 0);
        }}
      />
    </label>
    <label>
      <span className="mb-2 block text-sm font-bold">Para Birimi</span>
      <select className={inputClass} value={formData.currency || 'TRY'} onChange={(e) => onChange('currency', e.target.value)}>
        {['TRY', 'USD', 'EUR', 'GBP'].map((currency) => <option key={currency} value={currency}>{currency}</option>)}
      </select>
    </label>
  </div>
);

export default PersonnelCompensationFields;
